/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-14 11:22:01
 * @LastEditTime: 2019-09-20 11:46:22
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue'
import vuex from 'vuex'
import user from './modules/user'
import base from './modules/base'
import login from "./modules/login";
import formulaStore from './modules/formula'

Vue.use(vuex)

export default new vuex.Store({
  state: {
    system: '',
    isWeChat: false,
    platform:'WeChat',
    notNeedLogin: 0, // 进入APP是否需要强制登陆， 0 不需要 1 需要
    isApp: 0, // 是否APP，0不是 1是
  },
  getters: {
    system (state) {
      return state.system
    },
    isWeChat (state) {
      return state.isWeChat
    },
    platform (state) {
      return state.platform
    },
    notNeedLogin (state) {
      return state.notNeedLogin
    },
    isApp (state) {
      return state.isApp
    },
  },
  modules: {
    user, base, login, formulaStore
  },
  mutations: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js